import React from 'react';
import { Calendar, ExternalLink } from 'lucide-react';
import { useDarkMode } from './DarkModeContext';

export default function UpdateDetailModal({ open, onClose, update }) {
  const { isDarkMode } = useDarkMode();
  if (!open || !update) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 backdrop-blur-sm animate-in fade-in duration-300">
      <div className={`rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto modal-scrollbar shadow-2xl transform transition-all duration-300 scale-100 animate-in slide-in-from-bottom-4 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className={`sticky top-0 border-b p-6 rounded-t-2xl ${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'}`}>
          <div className="flex items-start justify-between">
            <div className="flex-1 pr-4">
              <h2 className={`text-xl font-semibold ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Update Details</h2>
            </div>
            <button className={`transition-colors p-2 rounded-full ${isDarkMode ? 'text-gray-400 hover:text-gray-200 hover:bg-gray-800' : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'}`} onClick={onClose}>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
          </div>
        </div>
        <div className="p-6">
          <div className={`flex items-center space-x-2 text-sm mb-6 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            <Calendar className="w-4 h-4" />
            <span>{update?.formattedDate || update?.date}</span>
          </div>
          <div className={`prose prose-lg max-w-none ${isDarkMode ? 'text-gray-300' : 'text-black'}`}>
            <p className={`leading-relaxed text-lg mb-6 font-semibold ${isDarkMode ? 'text-gray-300' : 'text-black'}`}>{update?.summary}</p>
          </div>
          <div className="flex flex-wrap gap-2 mt-2 mb-6">
            {update?.tags && update.tags.map((tag, i) => (
              <span key={i} className={`px-3 py-1 rounded-full text-xs font-medium ${isDarkMode ? 'bg-fuchsia-900/50 text-fuchsia-300' : 'bg-fuchsia-100 text-fuchsia-800'}`}>{tag}</span>
            ))}
          </div>
          <div className={`border-t pt-6 ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
            {update?.link && (
              <a href={update.link} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center px-6 py-3 font-medium rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-lg bg-gradient-to-r from-red-600 to-blue-600 text-white hover:from-red-700 hover:to-blue-700`}>
                <ExternalLink className="w-5 h-5 mr-2" />Read Full Press Release
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
} 